/** 投标总览 — 多断点 panels 布局 */

function P(panels) {
  return panels.map((panel, id) => ({...panel, id}));
}

const HEAD_W = 15;
const STAT_H = 2.55;
const MOD_H = 4.5;

function bottomRow(y, h, leftW) {
  const col = leftW / 3;
  return [
    {x: 0, y, w: col, h, control: 'PanelBidDashboardDeadline'},
    {x: col, y, w: col, h, control: 'PanelBidDashboardBond'},
    {x: col * 2, y, w: col, h, control: 'PanelBidDashboardWaitingOpen'},
  ];
}

/** 右侧：三饼图 + 趋势 + 工作动态 */
function chartPanels(rx, rw) {
  const cw = rw / 3;
  const r1 = 2.75;
  const r2 = 2.5;
  const r3 = 11 - r1 - r2;
  return [
    {x: rx, y: 0, w: cw, h: r1, control: 'PanelBidDashboardChart', data: {chart: 'scale'}},
    {x: rx + cw, y: 0, w: cw, h: r1, control: 'PanelBidDashboardChart', data: {chart: 'type'}},
    {x: rx + cw * 2, y: 0, w: cw, h: r1, control: 'PanelBidDashboardChart', data: {chart: 'result'}},
    {x: rx, y: r1, w: rw, h: r2, control: 'PanelBidDashboardChart', data: {chart: 'trend'}},
    {x: rx, y: r1 + r2, w: rw, h: r3, control: 'PanelBidDashboardActivity'},
  ];
}

function leftPanels(headW, modH) {
  const top = STAT_H;
  const botY = top + modH;
  const botH = 11 - botY;
  const col = headW / 3;
  return [
    {x: 0, y: 0, w: headW, h: STAT_H, control: 'PanelBidDashboardStats'},
    {x: 0, y: top, w: col, h: modH, control: 'PanelBidDashboardModule', data: {module: 'info'}},
    {x: col, y: top, w: col, h: modH, control: 'PanelBidDashboardModule', data: {module: 'work'}},
    {x: col * 2, y: top, w: col, h: modH, control: 'PanelBidDashboardModule', data: {module: 'open'}},
    ...bottomRow(botY, botH, headW),
  ];
}

function desktop() {
  return P([
    ...leftPanels(HEAD_W, MOD_H),
    ...chartPanels(15, 9),
  ]);
}

function medium() {
  return P([
    ...leftPanels(14, 4.65),
    ...chartPanels(14, 10),
  ]);
}

function tablet() {
  const statH = 2.2;
  const top = statH;
  const botY = top + 2.85;
  const botH = 2.0;
  const cy = botY + botH;
  const ch = 11 - cy;
  return P([
    {x: 0, y: 0, w: 24, h: statH, control: 'PanelBidDashboardStats'},
    {x: 0, y: top, w: 8, h: 2.85, control: 'PanelBidDashboardModule', data: {module: 'info'}},
    {x: 8, y: top, w: 8, h: 2.85, control: 'PanelBidDashboardModule', data: {module: 'work'}},
    {x: 16, y: top, w: 8, h: 2.85, control: 'PanelBidDashboardModule', data: {module: 'open'}},
    ...bottomRow(botY, botH, 24),
    {x: 0, y: cy, w: 8, h: ch, control: 'PanelBidDashboardChart', data: {chart: 'scale'}},
    {x: 8, y: cy, w: 8, h: ch, control: 'PanelBidDashboardChart', data: {chart: 'type'}},
    {x: 16, y: cy, w: 8, h: ch, control: 'PanelBidDashboardChart', data: {chart: 'result'}},
  ]);
}

function mobile() {
  return P([
    {x: 0, y: 0, w: 24, h: 2.6, control: 'PanelBidDashboardStats'},
    {x: 0, y: 2.6, w: 24, h: 3.5, control: 'PanelBidDashboardModule', data: {module: 'info'}},
    {x: 0, y: 6.1, w: 24, h: 3.5, control: 'PanelBidDashboardModule', data: {module: 'work'}},
    {x: 0, y: 9.6, w: 24, h: 3.5, control: 'PanelBidDashboardModule', data: {module: 'open'}},
    {x: 0, y: 13.1, w: 24, h: 2.2, control: 'PanelBidDashboardDeadline'},
    {x: 0, y: 15.3, w: 24, h: 2.2, control: 'PanelBidDashboardBond'},
    {x: 0, y: 17.5, w: 24, h: 2.2, control: 'PanelBidDashboardWaitingOpen'},
    {x: 0, y: 19.7, w: 8, h: 2.8, control: 'PanelBidDashboardChart', data: {chart: 'scale'}},
    {x: 8, y: 19.7, w: 8, h: 2.8, control: 'PanelBidDashboardChart', data: {chart: 'type'}},
    {x: 16, y: 19.7, w: 8, h: 2.8, control: 'PanelBidDashboardChart', data: {chart: 'result'}},
    {x: 0, y: 22.5, w: 24, h: 2.4, control: 'PanelBidDashboardChart', data: {chart: 'trend'}},
    {x: 0, y: 24.9, w: 24, h: 2.8, control: 'PanelBidDashboardActivity'},
  ]);
}

export function buildBidDashboardPanels(width) {
  if (width < 768) return mobile();
  if (width < 1024) return tablet();
  if (width < 1400) return medium();
  return desktop();
}
